/*
  RACINESFIX - Visionneuse de la fiche produit
  ===========================================================================
  Pilote snippets/rx-viewer.liquid : les vignettes commandent l'image
  principale, les flèches et le compteur suivent.

  POURQUOI UN FICHIER SÉPARÉ ET NON UN AJOUT DANS racines.js
  ---------------------------------------------------------------------------
  racines.js est chargé sur TOUTES les pages depuis snippets/scripts.liquid,
  et il est partagé avec l'autre agent. Ce script-là ne sert qu'à la fiche
  produit : il est chargé par le snippet qui l'utilise, exactement comme
  racines-quiz.js l'est par blocs/rx-quiz.

  CE QU'IL NE FAIT PAS
  ---------------------------------------------------------------------------
  Il ne crée aucun mécanisme d'affichage qui lui serait propre. Le ruban
  `scroll-snap` fonctionne déjà sans lui : si ce fichier ne s'exécute pas,
  toutes les photos restent atteignables au doigt, à la molette et au
  clavier. Le script ne fait que DÉPLACER le ruban et tenir les états
  ARIA à jour. C'est la différence entre enrichir et rendre indispensable.
*/

(function () {
  'use strict';

  function initViewer(root) {
    var stage  = root.querySelector('[data-rx-vw-stage]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-rx-thumb]'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-rx-vw-slide]'));
    var index  = root.querySelector('[data-rx-vw-index]');
    var prev   = root.querySelector('[data-rx-vw-prev]');
    var next   = root.querySelector('[data-rx-vw-next]');

    if (!stage || !slides.length) return;

    var current = 0;

    /* `prefers-reduced-motion` : un défilement animé sur une commande
       explicite est précisément ce que ce réglage demande de supprimer.
       On lit la préférence à chaque appel plutôt qu'une fois au
       chargement, parce qu'elle peut changer pendant la session. */
    function behavior() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'auto'
        : 'smooth';
    }

    function paint(i) {
      current = i;

      thumbs.forEach(function (t, n) {
        var on = n === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        /* Un seul point d'entrée au clavier dans la liste d'onglets : on
           y entre par Tab, on y circule par les flèches. C'est le motif
           « tabindex roving », celui qu'attend un lecteur d'écran sur un
           role="tablist". */
        t.setAttribute('tabindex', on ? '0' : '-1');
      });

      if (index) index.textContent = String(i + 1);
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }

    function goTo(i, focusThumb) {
      if (i < 0 || i >= slides.length) return;
      /* scrollLeft plutôt que scrollIntoView : scrollIntoView fait aussi
         défiler la PAGE pour amener l'élément dans la fenêtre, donc un
         clic sur une vignette ferait sauter la page entière. */
      stage.scrollTo({ left: slides[i].offsetLeft - stage.offsetLeft, behavior: behavior() });
      paint(i);
      if (focusThumb && thumbs[i]) thumbs[i].focus();
    }

    thumbs.forEach(function (t, n) {
      t.addEventListener('click', function () { goTo(n, false); });
    });

    /* Navigation aux flèches dans la liste de vignettes. La liste est
       verticale sur bureau et horizontale sur mobile : on accepte les
       quatre flèches plutôt que de deviner l'orientation courante. */
    root.addEventListener('keydown', function (e) {
      if (!e.target.hasAttribute || !e.target.hasAttribute('data-rx-thumb')) return;
      var n = thumbs.indexOf(e.target);
      if (n < 0) return;
      var to = null;
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') to = n + 1;
      else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') to = n - 1;
      else if (e.key === 'Home') to = 0;
      else if (e.key === 'End') to = thumbs.length - 1;
      if (to === null) return;
      e.preventDefault();
      goTo(Math.max(0, Math.min(thumbs.length - 1, to)), true);
    });

    if (prev) prev.addEventListener('click', function () { goTo(current - 1, false); });
    if (next) next.addEventListener('click', function () { goTo(current + 1, false); });

    /* Le doigt peut faire défiler le ruban sans passer par une vignette.
       IntersectionObserver, et non un écouteur `scroll` : celui-ci se
       déclenche des centaines de fois par seconde et pèse directement
       sur l'INP (v3 PARTIE 13). */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio > 0.6) {
            var n = slides.indexOf(en.target);
            if (n >= 0 && n !== current) paint(n);
          }
        });
      }, { root: stage, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    }

    paint(0);
  }

  function boot() {
    document.querySelectorAll('[data-rx-vw]').forEach(initViewer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* L'éditeur de thème recharge une section sans recharger la page : sans
     ce branchement, la visionneuse serait morte après chaque modification
     dans l'aperçu, et paraîtrait cassée à qui la teste. */
  document.addEventListener('shopify:section:load', boot);
})();
